/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  RichiesteCausaliCdlInsertDTO,
  RichiesteCausaliCdlResponseDTO,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RichiesteCausaliCdlInsertDTOFromJSON,
    RichiesteCausaliCdlInsertDTOToJSON,
    RichiesteCausaliCdlResponseDTOFromJSON,
    RichiesteCausaliCdlResponseDTOToJSON,
} from '../models/index';

export interface DeleteRichiestaCausaleCdlRequest {
    id: number;
}

export interface GetRichiestaCausaleCdLRequest {
    id: number;
}

export interface InsertRichiestaCausaleCdlRequest {
    richiesteCausaliCdlInsertDTO?: RichiesteCausaliCdlInsertDTO;
}

/**
 * 
 */
export class RichiesteCausaliCDLApi extends runtime.BaseAPI {

    /**
     */
    async deleteRichiestaCausaleCdlRaw(requestParameters: DeleteRichiestaCausaleCdlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRichiestaCausaleCdl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/RichiesteCausaliCdl/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRichiestaCausaleCdl(requestParameters: DeleteRichiestaCausaleCdlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRichiestaCausaleCdlRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getRichiestaCausaleCdLRaw(requestParameters: GetRichiestaCausaleCdLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RichiesteCausaliCdlResponseDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRichiestaCausaleCdL().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/RichiesteCausaliCdl/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RichiesteCausaliCdlResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getRichiestaCausaleCdL(requestParameters: GetRichiestaCausaleCdLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RichiesteCausaliCdlResponseDTO> {
        const response = await this.getRichiestaCausaleCdLRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRichiesteCausaliCdlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RichiesteCausaliCdlResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/RichiesteCausaliCdl`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RichiesteCausaliCdlResponseDTOFromJSON));
    }

    /**
     */
    async getRichiesteCausaliCdl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RichiesteCausaliCdlResponseDTO>> {
        const response = await this.getRichiesteCausaliCdlRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async insertRichiestaCausaleCdlRaw(requestParameters: InsertRichiestaCausaleCdlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/RichiesteCausaliCdl/insertRichiestaCausaleCdl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RichiesteCausaliCdlInsertDTOToJSON(requestParameters['richiesteCausaliCdlInsertDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async insertRichiestaCausaleCdl(requestParameters: InsertRichiestaCausaleCdlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.insertRichiestaCausaleCdlRaw(requestParameters, initOverrides);
    }

}
